import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import { ProvedorDeAvisos } from "./ui/avisos";
import { ProvedorDeTema } from "./ui/tema";
import { App } from "./App";
import { ProvedorDeIdioma } from "./i18n";
import { iniciarRelatorioDeErros } from "./erros";
import { bloquearArrastoNativo } from "./ui/semArrastoNativo";
import "./styles/base.css";
/*
 * A arte entra depois da base, e a ordem importa.
 *
 * `arte.css` troca o ponteiro de `button` e de `a`, que a base já define
 * com a mesma especificidade. Importado antes, ele perderia por ordem de
 * origem e o ponteiro desenhado só apareceria em metade da tela. `@import`
 * dentro da base não resolveria: a regra manda que ele venha antes de tudo.
 */
import "./styles/arte.css";

// Antes de qualquer coisa, para pegar também o que quebrar na montagem. Sem
// endereço configurado não envia nada e o jogo funciona igual.
iniciarRelatorioDeErros();
bloquearArrastoNativo();

const container = document.getElementById("root");
if (!container) throw new Error("Elemento #root não encontrado.");

createRoot(container).render(
  <StrictMode>
    {/* O idioma padrão é pt-BR. A estrutura já aceita outro sem mexer nas telas. */}
    <ProvedorDeIdioma>
      {/* Dentro do idioma, porque o recado é texto e o botão de fechar dele
          precisa do rótulo traduzido. */}
      <ProvedorDeTema>
        <ProvedorDeAvisos>
          <App />
        </ProvedorDeAvisos>
      </ProvedorDeTema>
    </ProvedorDeIdioma>
  </StrictMode>,
);
